/**
 * Normalize a polar frame's gate payload for WebGL.
 * Accepts Uint8Array (browser decode), number arrays, or legacy base64.
 */
export function decodePolarData(polarData) {
  if (!polarData || polarData.data == null) {
    throw new Error("Radar payload missing encoded gate data");
  }
  let values;
  if (polarData.data instanceof Uint8Array) {
    values = polarData.data;
  } else if (Array.isArray(polarData.data)) {
    values = Uint8Array.from(polarData.data);
  } else if (typeof polarData.data === "string") {
    const normalized = polarData.data.replace(/\s+/g, "").replace(/-/g, "+").replace(/_/g, "/");
    const padLen = (4 - (normalized.length % 4)) % 4;
    const padded = normalized + "=".repeat(padLen);
    let raw;
    try {
      raw = atob(padded);
    } catch {
      throw new Error("Radar payload decode failed (invalid base64)");
    }
    values = new Uint8Array(raw.length);
    for (let i = 0; i < raw.length; i++) values[i] = raw.charCodeAt(i);
  } else {
    throw new Error("Radar payload missing encoded gate data");
  }

  return {
    values,
    numAz: polarData.azimuths.length,
    numGates: polarData.num_gates,
    azimuthStartDeg: polarData.azimuths[0] || 0,
  };
}
